module.exports = __webpack_public_path__ + "static/media/image_yellow@2x-min.1113aa23.jpg";